module.exports = __webpack_public_path__ + "static/media/logo_daito.350454cc.png";